// @ts-nocheck
import { Plugin } from '/root/workspace/jst-gyl_53Ms/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','dva','getInitialState','initialStateConfig','request',],
});

export { plugin };
